import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import useMidType from './useMidType.mjs'

export default function PropertiesControllerSelectMidType(props) {
    const {pairs: midTypePairs} = useMidType()

    return (
        <Select
            mapOption={{label: e => e.middlewareTypeName}}
            options={midTypePairs}
            prop="middlewareType"
            {...props}
        />
    )
}
